import React from 'react';

import InputContainer from '../InputContainer/input-container';

export default class TextInput extends React.PureComponent {
	render() {
		return (
			<InputContainer
				validationError={this.props.validationError}
				id={this.props.id}
				label={this.props.label}
				helpText={this.props.optional ? 'Optional' : ''}
				width={this.props.width}
				labelAfterInput={this.props.labelAfterInput}
				body={
					<input
						name={this.props.name}
						type={this.props.type ? this.props.type : 'text'}
						format={this.props.format}
						id={this.props.id}
						value={this.props.value || ''}
						required={!this.props.optional}
						onChange={this.props.onChange}
						placeholder={this.props.placeholder}
						className="form-control"
						onFocus={this.props.onFocus}
						onBlur={this.props.onBlur}
					/>
				}
			/>
		);
	}
}
